<template>
	<ActivityLayout class="kr-creation-activity">
		<template #badge>
			<NewItemActivityBadge />
		</template>
		<template #text>
			<p>{{ translate( "text", { changedBy: activity.changedBy } ) }}</p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import NewItemActivityBadge from "../Activity/NewItemActivityBadge";

export default {
	name: "KRCreationActivity",
	components: {
		ActivityLayout,
		NewItemActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.KRCreationActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
